import { Grid, Typography } from '@mui/material'
import React from 'react'
import { ReactComponent as VerifiedIcon } from '../../../../../assets/svg/verified-new-icon.svg';
import FxLabelView from '../../../../Input/FxLabel/FxLabelView';


/**
 * Author : Shivaraj PP
 * Component: JointTenancyCoOwnerReviewInfoCardView
 * Description: Review Info Card View
 */
const JointTenancyCoOwnerReviewInfoCardView: React.FC<any> = React.memo((props) => {
  return (
    <Grid container className={'fx-review-info-card-item wrapper-name-fields'} key={props?.index}>
      <Grid container item xs={12}>
        {props?.item.name && (
          <Grid item xs={12}>
            <Typography variant="h3" className={'fx-review-info-card-item-header'}>{props?.item.name}</Typography>
          </Grid>
        )}
        {Object.keys(props?.item.data).map((key) => (
          !!props?.item.data[key].value && (
            <Grid item xs={12} key={key} className={'fx-review-info-card-data-item'}>
              <Grid item container xs={12}>
                {key === 'authSignatory' && (
                  <Grid item xs={'auto'} container alignItems={'center'} className={'fx-review-info-card-data-item-auth-signatory-label'}>
                    <VerifiedIcon /><FxLabelView>&nbsp;AUTHORIZED SIGNATORY</FxLabelView>
                  </Grid>
                )}
              </Grid>
              <Typography className={'fx-review-info-card-data-item-info'}>
                {props?.item.data[key].title ? `${props?.item.data[key].title} ` : ''}{props?.item.data[key].value}
              </Typography>
            </Grid>
          )
        ))}
      </Grid>
    </Grid>
  )
})

export default JointTenancyCoOwnerReviewInfoCardView